import React, { useState } from "react";
import { toast } from "react-toastify";
import { utilService } from "services";
import DroneList from "./DroneList";
import DroneModal from "./DroneModal";

const MachineSection = ({ user, selectedMachines, setSelectedMachines }) => {
    const [showDroneModal, setShowDroneModal] = useState(false);
    const [editingMachineIndex, setEditingMachineIndex] = useState(null);
    const [machineFormValues, setMachineFormValues] = useState({
        make: "",
        model: "",
        type: "",
        image: "",
    });
    const [isMachineImageLoading, setIsMachineImageLoading] = useState(false);

    const handleOpenMachineModal = (machine = null, index = null) => {
        if (machine) {
            setMachineFormValues({
                make: machine.make || "",
                model: machine.model || "",
                type: machine.type || "",
                image: machine.image || "",
            });
            setEditingMachineIndex(index);
        } else {
            setMachineFormValues({ make: "", model: "", type: "", image: "" });
            setEditingMachineIndex(null);
        }
        setShowDroneModal(true);
    };

    const handleMachineImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const extension = file.name.split(".").pop();
        try {
            setIsMachineImageLoading(true);
            const response = await utilService.getBucketUrl({
                location: "portfolio/",
                extension,
            });
            const { filename, url } = response.data.data[0];
            await utilService.uploadFile({
                url,
                requestOptions: {
                    method: "PUT",
                    headers: { "Content-Type": file.type },
                    body: file,
                    redirect: "follow",
                },
            });

            setMachineFormValues((prev) => ({ ...prev, image: filename }));
        } catch (err) {
            console.log(err);
            toast.error("Failed to upload image");
        } finally {
            setIsMachineImageLoading(false);
        }
    };

    const handleSaveMachineForm = () => {
        if (!machineFormValues.make || !machineFormValues.model) {
            toast.warning("Please fill required fields");
            return;
        }

        const newMachines = [...selectedMachines];
        const machineData = {
            make: machineFormValues.make,
            model: machineFormValues.model,
            type: machineFormValues.type,
            image: machineFormValues.image,
        };

        if (editingMachineIndex !== null) {
            newMachines[editingMachineIndex] = {
                ...newMachines[editingMachineIndex],
                ...machineData,
            };
        } else {
            newMachines.push({
                _id: Date.now().toString(),
                ...machineData,
            });
        }
        setSelectedMachines(newMachines);
        setShowDroneModal(false);
    };

    const handleRemoveMachine = (index) => {
        setSelectedMachines(selectedMachines.filter((_, i) => i !== index));
    };

    return (
        <>
            <DroneList
                user={user}
                selectedMachines={selectedMachines}
                handleOpenMachineModal={handleOpenMachineModal}
                handleRemoveMachine={handleRemoveMachine}
            />
            <DroneModal
                show={showDroneModal}
                onHide={() => setShowDroneModal(false)}
                editingMachineIndex={editingMachineIndex}
                machineFormValues={machineFormValues}
                setMachineFormValues={setMachineFormValues}
                handleMachineImageUpload={handleMachineImageUpload}
                isMachineImageLoading={isMachineImageLoading}
                handleSaveMachineForm={handleSaveMachineForm}
                user={user}
            />
        </>
    );
};

export default MachineSection;
